var _path, _circle, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 29H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h28a1 1 0 0 1 1 1v24a1 1 0 0 1-1 1zM3 27h26V5H3v22z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.769,
    cy: 9.4,
    r: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.769 13.548a3.768 3.768 0 0 0-3.715 4.399l.153.898c.084.498.516.863 1.02.863h.094l.446 4.237A1.163 1.163 0 0 0 9.925 25h1.688c.6 0 1.102-.457 1.157-1.055l.447-4.237h.093c.505 0 .937-.365 1.021-.863l.153-.898a3.768 3.768 0 0 0-3.715-4.399zM25 15h-6.781a1 1 0 1 1 0-2H25a1 1 0 1 1 0 2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.61 19h-3.391a1 1 0 1 1 0-2h3.39a1 1 0 1 1 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.34f88b9242ea357f9d2865561d74b6f0.svg";
export { ForwardRef as ReactComponent };